export const DataNumbers = [
  {
    key: "2002",
    investors_profit: "000 млн ₽",
    invested_by_investors: "00",
    profit: "23%",
    transactions: "0000",
    re_invest: "15%",
    investor_check: "00 00"
  },
  {
    key: "2001",
    investors_profit: "00 ии ₽",
    invested_by_investors: "000 вв ₽",
    profit: "10%",
    transactions: "000",
    re_invest: "20%",
    investor_check: "000 вв ₽"
  },
  {
    key: "2000",
    investors_profit: "00 ааа ₽",
    invested_by_investors: "000 ооо ₽",
    profit: "17%",
    transactions: "000",
    re_invest: "27%",
    investor_check: "000 вв ₽"
  }
]
